import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Box } from "@mui/material";

import {
  getAllClientsNoPagination,
  getClientIdByToken,
  useMalimaxDashboardContainers,
  validTaskCodeByToken,
  generateMalimaxOnePdfReportbyId,
  generateMalimaxTwoPdfReportbyId,
  generateMalimaxThreePdfReportbyId,
} from "../../../../../libs/apis";
import { ClientI, WorkflowContainerI } from "../../../../../libs/interfaces";
import { SendReport } from "../../../../../libs/shared";
import { DashboardTable } from "./dashboard-table";
import type { ColumnsType } from "antd/es/table";
import { useWidth } from "../../../../../libs/hooks";
import { Environments } from "../../../../../libs/enums";
import "../../../../../libs/css/list.css";
import {
  Button as ButtonAntd,
  Tooltip as TooltipAntd,
  message,
  Select,
} from "antd";
import { ShowContainer as ShowOne } from "../../../../../components/malimax-one/components/list/show-container";
import { ShowContainer as ShowTwo } from "../../../../../components/malimax-two/components/list/show-container";
import { ShowContainer as ShowThree } from "../../../../../components/malimax-three/components/list/show-container";
import {
  FilePdfOutlined,
  // FundViewOutlined,
} from "@ant-design/icons";

const titleExport = "ContenedorFull";
const routeEdit = "/container/full/edit/";

export const TableComponent = ({
  typeProcess,
  period,
}: {
  typeProcess: string;
  period: string;
}) => {
  const width = useWidth();
  const [messageApi, contextHolder] = message.useMessage();
  const [sorting, setSorting] = useState([{ id: "id", desc: true }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: width === "ab" ? 10 : width === "xl" ? 10 : 10,
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const [clientName, setClientName] = useState<any>(null);
  const [client, setClient] = useState<any>(null);
  const [clients, setClients] = useState<ClientI[]>([]);
  const { malimaxDashboardQuery } = useMalimaxDashboardContainers({
    sorting,
    pagination,
    globalFilter,
    client,
    typeProcess,
    period,
  });
  const { data, isLoading, refetch, isRefetching } = malimaxDashboardQuery;
  const [rowSelection, setRowSelection] = useState({});

  const [isGeneratingPdf, setGeneratingPdf] = useState(false);
  const [showExporters, setShowExporters] = useState(false);

  useEffect(() => {
    handleGetData();
    return () => {
      setShowExporters(false);
    };
  }, []);



  const handleGetData = async () => {
    const { data: dataClient } = await getClientIdByToken();
    if (dataClient) {
      setClient(dataClient);
    }

    const { data: dataTask } = await validTaskCodeByToken(
      Environments.TASK_WORKFLOW_ONE_ASIGNAR
    );

    if (!dataTask) return;
    if (dataTask.status) {
      setShowExporters(true);
      const { data: dataClients } = await getAllClientsNoPagination();
      if (!dataClients) return;
      setClients(dataClients);
    }
  };

  const columns = useMemo<ColumnsType<WorkflowContainerI>>(
    () => [
      {
        title: "Contenedor",
        dataIndex: "container",
        width: 150,
        render: (value: string, row: WorkflowContainerI) => (
          <a className="b-proform" onClick={() => handlePdf(row)}>
            {value}
          </a>
        ),
      },
      {
        title: "Cliente",
        dataIndex: "client",
        width: 260,
        ellipsis: true,
        responsive: ["sm"],
      },
      {
        title: "Usuario Creación",
        dataIndex: "userCreation",
        width: 190,
        responsive: ["lg"],
      },
      { title: "Tipo Proceso", dataIndex: "processType", width: 130 },
      { title: "Hora", dataIndex: "hour", width: 100, responsive: ["md"] },
      {
        title: "Creación",
        dataIndex: "createdAt",
        width: 160,
        responsive: ["md"],
      },
    ],
    []
  );





  const handlePdf = async (row: WorkflowContainerI) => {
    try {
      setGeneratingPdf(true);

      messageApi.open({
        key: "generatePdfKey1",
        type: "loading",
        content: "Generando Pdf",
        duration: 50,
      });
      if (row.processType === "Proceso 1") {
        const { data: dataPdfOne } = await generateMalimaxOnePdfReportbyId(row.id!);
        messageApi.destroy();
        messageApi.open({
          key: "generatePdfKey4",
          type: "loading",
          content: "Procesando Pdf",
          duration: 2,
          onClose: () => {
            message.success("PDF Descargado", 1);
          },
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = `data:application/pdf;base64,${dataPdfOne}`;
        downloadLink.download = `report-${row.container}.pdf`;
        downloadLink.click();
        setGeneratingPdf(false);
      } else if (row.processType === "Proceso 2") {
        const { data: dataPdfTwo } = await generateMalimaxTwoPdfReportbyId(row.id!);
        messageApi.destroy();
        messageApi.open({
          key: "generatePdfKey4",
          type: "loading",
          content: "Procesando Pdf",
          duration: 2,
          onClose: () => {
            message.success("PDF Descargado", 1);
          },
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = `data:application/pdf;base64,${dataPdfTwo}`;
        downloadLink.download = `report-${row.container}.pdf`;
        downloadLink.click();
        setGeneratingPdf(false);
      } else if (row.processType === "Proceso 3") {
        const { data: dataPdfThree } = await generateMalimaxThreePdfReportbyId(row.id!);
        messageApi.destroy();
        messageApi.open({
          key: "generatePdfKey4",
          type: "loading",
          content: "Procesando Pdf",
          duration: 2,
          onClose: () => {
            message.success("PDF Descargado", 1);
          },
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = `data:application/pdf;base64,${dataPdfThree}`;
        downloadLink.download = `report-${row.container}.pdf`;
        downloadLink.click();
        setGeneratingPdf(false);
      }
    } catch (err: any) {
      messageApi.destroy();
      message.error(`Error al generar el pdf: ${err.toString()}`);
      setGeneratingPdf(false);
    }
  };


  return (
    <Fragment>
      {contextHolder}
      <DashboardTable<WorkflowContainerI>
        columns={columns}
        data={data?.data?.dato ?? []}
        total={data?.data?.total ?? 0}
        loading={isLoading || isRefetching}
        pagination={pagination}
        setPagination={setPagination}
        sorting={sorting}
        setSorting={setSorting}
        setGlobalFilter={setGlobalFilter}
        onRefresh={() => refetch()}
        exportTitle="ContenedorFull"
        actionsWidth={140}
        toolbarExtra={
          showExporters ? (
            <Select
              showSearch
              allowClear
              style={{ minWidth: 200, flex: "1 1 200px", maxWidth: 280 }}
              placeholder="Cliente"
              optionFilterProp="label"
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={clients.map((el) => ({
                label: el.name,
                value: el.name,
              }))}
              value={clientName}
              onChange={(value) => {
                setClientName(value);
                const findProducer = clients.find((el) => el.name === value);
                if (findProducer) {
                  setClient(findProducer.id);
                } else {
                  setClient(null);
                }
              }}
            />
          ) : null
        }
        renderActions={(row) => (
          <Box sx={{ display: "flex", gap: "0.4rem", justifyContent: "center" }}>
            <TooltipAntd arrow={false} title="Pdf">
              <ButtonAntd
                loading={isGeneratingPdf}
                disabled={isGeneratingPdf}
                size="small"
                type="dashed"
                onClick={() => handlePdf(row)}
                icon={<FilePdfOutlined />}
              />
            </TooltipAntd>
            <SendReport
              id={row.id!}
              typeWf={
                row.processType === "Proceso 1"
                  ? "malimax"
                  : row.processType === "Proceso 2"
                  ? "malimaxTwo"
                  : "malimaxThree"
              }
            />
            {row.processType === "Proceso 1" ? (
              <ShowOne id={row.id!} />
            ) : null}
            {row.processType === "Proceso 2" ? (
              <ShowTwo id={row.id!} />
            ) : null}
            {row.processType === "Proceso 3" ? (
              <ShowThree id={row.id!} />
            ) : null}
          </Box>
        )}
      />
    </Fragment>
  );
};
